import React, { useState, useEffect } from 'react';
import './AboutCarousel.css';

const slides = [
  {
    title: "Welcome to My World",
    content: `Hi, I’m Vanessa — a developer with a background in healthcare and a lifelong pull toward design, art, and building things. Creative problem-solving has always been my thing. Front-end development felt like the perfect overlap: structure meets curiosity. So I studied software engineering, built my toolkit, and here I am — turning questions into code.`,
    
  },
  {
    title: "The Shift",
    content: `I’ve always liked figuring out how things work — through design, DIY, or sheer curiosity. It took me a while to realize tech could be creative too. Once it clicked, I knew: I want to build the digital things people actually use.`,
  },
  {
    title: "What Drives Me",
    content: `I care about great UX, clean design, and code that feels intuitive. Whether it’s a dashboard or a landing page, I want every interaction to feel smooth, clear, and intentional.`,
  },
  {
    title: "More About Me",
    content: (
      <>
        <p>
          When I’m not coding, I’m probably DIYing, sketching, hiking city trails or getting lost in a design rabbit hole. 
          I like blending logic with creativity — powered by dark roast, carrot cake, and unchecked curiosity.
        </p>
      </>
    )
    
  },
  {
    title: "Tech & Tools",
    content: `HTML, CSS, JavaScript, Java, Python, MongoDB, C#, Kotlin. React, Git, Figma. I focus on building responsive, accessible UI/UX.`,
  },
  {
    title: "Let’s Connect",
    content: `If you're building something thoughtful, curious, or quietly brilliant — I’d love to chat. I believe in collaboration, lifelong learning, and making tech feel human.`,
  },
];

export default function AboutCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(null); // ✅ safe initial state

  // ✅ Detect viewport width safely
  useEffect(() => {
    const checkSize = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth < 768);
      }
    };
    checkSize(); // run once on mount
    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, []);

  // ✅ Prevent blank render until we know the viewport
  if (isMobile === null) {
    return null;
  }

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  // 📱 Mobile version — scrollable layout
  if (isMobile) {
    return (
      <div className="about-mobile">
        <img
          className="about-mobile-photo"
          src="/images/vanessa-photo.jpg"
          alt="Vanessa Victorino"
        />
        {slides.map((slide, index) => (
          <section key={index} className="about-mobile-section">
            <h2>{slide.title}</h2>
            <p>{slide.content}</p>
            {slide.links && (
              <ul className="slide-links">
                {slide.links.map((link, i) => (
                  <li key={i}>
                    <a href={link.url} target="_blank" rel="noopener noreferrer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    );
  }

  // 💻 Desktop version — carousel
  return (
    <div className="about-carousel-wrapper">
      <div className="carousel-left">
        <img src="/images/vanessa-photo.jpg" alt="Vanessa Victorino" />
      </div>

      <div className="carousel-right">
        <div className="slide">
          <h2>{slides[currentSlide].title}</h2>
          <p>{slides[currentSlide].content}</p>

          {slides[currentSlide].links && (
            <ul className="slide-links">
              {slides[currentSlide].links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="carousel-controls">
          <button onClick={prevSlide}>&larr; Prev</button>
          <button onClick={nextSlide}>Next &rarr;</button>
        </div>
      </div>
    </div>
  );
}
